import { LegalDocument, toDocxExportUrl, toPdfExportUrl } from './legalDocuments';
import { legalButtonBase, legalTitleStyle } from './legalPageStyles';

type LegalPageHeaderProps = {
  document: LegalDocument;
};

const DownloadButtons = ({ googleDocId, compact }: { googleDocId: string; compact: boolean }) => {
  const fontSize = compact ? '12px' : '13px';
  const padding = compact ? '7px 18px' : '8px 20px';

  return (
    <div style={{ display: 'flex', gap: compact ? '8px' : '10px', flexShrink: 0, justifyContent: 'center' }}>
      <a
        href={toPdfExportUrl(googleDocId)}
        target='_blank'
        rel='noopener noreferrer'
        className='aida-button aida-button-outline-fill'
        style={{ ...legalButtonBase, fontSize, padding }}
      >
        <span className='text'>Download PDF</span>
      </a>
      <a
        href={toDocxExportUrl(googleDocId)}
        target='_blank'
        rel='noopener noreferrer'
        className='aida-button'
        style={{ ...legalButtonBase, fontSize, padding, background: '#FBBF24', color: '#161423' }}
      >
        <span className='text'>Download DOCX</span>
      </a>
    </div>
  );
};

export const LegalPageHeader = ({ document }: LegalPageHeaderProps) => {
  const downloads = document.showDownloads && document.googleDocId ? (
    <DownloadButtons googleDocId={document.googleDocId} compact />
  ) : null;
  const mobileDownloads = document.showDownloads && document.googleDocId ? (
    <DownloadButtons googleDocId={document.googleDocId} compact={false} />
  ) : null;

  return (
    <>
      <div
        className='hidden lg:flex'
        style={{
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          gap: '16px',
          marginBottom: '20px',
          textAlign: 'center',
        }}
      >
        <h1 style={{ ...legalTitleStyle, fontSize: '28px', lineHeight: '36px', textAlign: 'center' }}>{document.title}</h1>
        {downloads}
      </div>

      <div
        className='flex flex-col items-center lg:hidden'
        style={{ gap: '16px', marginBottom: '20px', padding: '0 8px' }}
      >
        <h1 style={{ ...legalTitleStyle, fontSize: '48px', lineHeight: '54px', textAlign: 'center' }}>
          {document.mobileTitleLines.map((line, index) => (
            <span key={line}>
              {index > 0 ? <br /> : null}
              {line}
            </span>
          ))}
        </h1>
        {mobileDownloads}
      </div>
    </>
  );
};
